import { render, staticRenderFns } from "./TableListServicesTypes.vue?vue&type=template&id=2fbcc33f"
import script from "./TableListServicesTypes.vue?vue&type=script&lang=js"
export * from "./TableListServicesTypes.vue?vue&type=script&lang=js"
import style0 from "./TableListServicesTypes.vue?vue&type=style&index=0&id=2fbcc33f&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbcc33f')) {
      api.createRecord('2fbcc33f', component.options)
    } else {
      api.reload('2fbcc33f', component.options)
    }
    module.hot.accept("./TableListServicesTypes.vue?vue&type=template&id=2fbcc33f", function () {
      api.rerender('2fbcc33f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListServicesTypes.vue"
export default component.exports